/**
 * Capacità di Forgiatura — lightbox card (PhotoSwipe).
 *
 * Al click sul render di una card ([data-forging-gallery] sul <ul> di ogni
 * gruppo, anchor .forging-card__media-link) si apre PhotoSwipe. Ogni gruppo è
 * una galleria a sé: prev/next scorre le 4 card del gruppo. Didascalia in
 * overlay dal data-pswp-caption (stesso pattern di src/js/flex-gallery.js).
 *
 * Markup: template-parts/forgiatura/{group,card}.php
 */
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

( function () {
	'use strict';

	if ( ! document.querySelector( '[data-forging-gallery]' ) ) {
		return;
	}

	const lightbox = new PhotoSwipeLightbox( {
		gallery: '[data-forging-gallery]',
		children: 'a.forging-card__media-link',
		pswpModule: PhotoSwipe,
		bgOpacity: 0.96,
		wheelToZoom: true,
		padding: { top: 40, bottom: 60, left: 24, right: 24 },
	} );

	// Didascalia in overlay (dal data-pswp-caption dell'anchor attivo).
	lightbox.on( 'uiRegister', () => {
		lightbox.pswp.ui.registerElement( {
			name: 'forging-caption',
			order: 9,
			isButton: false,
			appendTo: 'root',
			onInit: ( el, pswp ) => {
				el.className = 'forging-pswp__caption';
				pswp.on( 'change', () => {
					const anchor = pswp.currSlide && pswp.currSlide.data.element;
					el.textContent = anchor ? ( anchor.getAttribute( 'data-pswp-caption' ) || '' ) : '';
				} );
			},
		} );
	} );

	lightbox.init();
}() );
